import React from 'react'
import { useGetLandingPageJobsQuery } from '../redux/query/LandingPagesApi.slice'
import ErrorLoading from '../../../react/core/ErrorLoading'
import Loading from '../../../react/core/Loading'
import RecentJobs from '../../components/RecentJobs'

/**
 * Renders a list of four recent jobs.
 * @param {object} landingPage The landing page to load jobs from.
 * @returns {JSX.Element}
 */
export default function LandingPageRecentJobs ({ landingPage }) {
  const { data: jobs, isError, isLoading } = useGetLandingPageJobsQuery({ landingPageIdentifier: landingPage.identifier, limit: 4, order_by: 'published_at', order_direction: 'DESC' })

  if (isError) {
    return <ErrorLoading />
  }

  if (isLoading) {
    return <Loading />
  }

  return <RecentJobs jobPostings={jobs.items} color={landingPage.button_background_color}/>
}
